/**
 * Created by daniel.gonzalez on 6/12/15.
 */

'use strict';

var deepLink = require('../../../global/core/deepLink');
var matLink = require('../helpers/matLink');
var constants = require('../mobileAdsConstants');

module.exports = {
    closeAd(e) {
        e.preventDefault();
        this.trackingOnClose();
        this.remove();
    },

    redirectToApp(e) {
        let config = this.getMATConfig();
        let link = deepLink.createDeepLink();
        let srcLink = matLink.createMATTrackingLink(config, link);
        let optionalLink = constants.ITUNES_LINK;

        e.preventDefault();

        this.redirectInIframe(srcLink, link, optionalLink);
        this.trackingOnContinueToApp();
        this.remove();
    }
};



// WEBPACK FOOTER //
// ./assets/js/global/mobileAds/mixins/fullscreenMixin.es.js